var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_96232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C13.2272 0 8.64563 1.89759 5.27344 5.27203C1.8978 8.64783 0.000965949 13.226 0 18C0 22.772 1.89844 27.3535 5.27344 30.728C8.64563 34.1024 13.2272 36 18 36C22.7728 36 27.3544 34.1024 30.7266 30.728C34.1016 27.3535 36 22.772 36 18C36 13.228 34.1016 8.64647 30.7266 5.27203C27.3544 1.89759 22.7728 0 18 0Z",
    fill: "url(#paint0_linear_657_96232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14825 17.8098C13.3964 15.5238 16.8951 14.0167 18.6445 13.2884C23.6451 11.2092 24.6829 10.848 25.3608 10.8358C25.5098 10.8334 25.8417 10.8703 26.0583 11.0453C26.2383 11.193 26.2889 11.3927 26.3142 11.5329C26.3367 11.6729 26.3676 11.9922 26.3423 12.2413C26.0723 15.0876 24.8995 21.9945 24.3033 25.1825C24.0529 26.5314 23.5551 26.9836 23.0742 27.0278C22.0279 27.124 21.2348 26.337 20.2223 25.6736C18.6389 24.6349 17.7445 23.9886 16.2061 22.9753C14.4286 21.8041 15.5817 21.1603 16.5942 20.1085C16.8586 19.8331 21.4654 15.6439 21.5526 15.2639C21.5639 15.2164 21.5751 15.0392 21.4683 14.9458C21.3642 14.8522 21.2095 14.8843 21.097 14.9096C20.9367 14.9456 18.4083 16.6184 13.5033 19.9279C12.7861 20.4212 12.1364 20.6617 11.5514 20.649C10.9101 20.6353 9.67263 20.2857 8.75294 19.987C7.62794 19.6205 6.73075 19.4267 6.8095 18.8043C6.84888 18.4803 7.29607 18.1487 8.14825 17.8098Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_657_96232",
    x1: 1800,
    y1: 0,
    x2: 1800,
    y2: 3600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_96232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.702c9c94c10b79199446e22e1b2e651f.svg";
export { ForwardRef as ReactComponent };